import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackgroundIllustrations from '../../components/common/BackgroundIllustrations';
import AdminLoginForm from '../../components/admin/AdminLoginForm';
import AdminService from '../../services/admin.service';

const AdminAuthPage = () => {
 const navigate = useNavigate();
 const [error, setError] = useState('');

 const handleLogin = async (credentials) => {
   console.log("[DEBUG] handleAdminLogin - enter", credentials);
   
   try {
     setError('');
     const response = await AdminService.login(credentials);
     
     if (response.token) {
       localStorage.setItem('auth_token', response.token);
       localStorage.setItem('user', JSON.stringify(response.user));
       console.log("[DEBUG] Admin login success", response);
       navigate('/admin/dashboard');
     }
   } catch (error) {
     console.error("[DEBUG] Admin login error:", error);
     setError(error.message || 'Errore durante il login');
   }
 };

 return (
   <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-white">
     <BackgroundIllustrations className="absolute inset-0 z-0 opacity-50" />
     
     <div className="relative z-10 p-4">
       <div className="max-w-7xl mx-auto">
         <div className="flex justify-between items-center">
           <div className="text-sm text-blue-600">Area Amministrazione</div>
           <a 
             href="/"
             className="text-sm text-gray-600 hover:text-blue-600"
           >
             Torna al sito principale
           </a>
         </div>
       </div>
     </div>

     <div className="flex-grow flex items-center justify-center relative z-10 p-4">
       <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
         {error && (
           <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
             {error}
           </div>
         )}
         <AdminLoginForm onSubmit={handleLogin} />
       </div>
     </div>

     <div className="relative z-10 p-4 text-center text-sm text-gray-600">
       <p>Area riservata agli amministratori del sistema</p>
     </div>
   </div>
 );
};

export default AdminAuthPage;